// /src/utils/errorCapture.js
// Global error capture and navigation breadcrumb trail for error reporting
// Populates window.__ournetErrors and window.__ournetBreadcrumbs
// Referenced by ErrorReportModal's buildDebugContext()

const MAX_ERRORS = 10;
const MAX_BREADCRUMBS = 20;

// Call from components at key action points (form submits, auth attempts, etc.)
export function addBreadcrumb(type, data) {
  if (!window.__ournetBreadcrumbs) window.__ournetBreadcrumbs = [];
  window.__ournetBreadcrumbs.push({ type, ...data, time: new Date().toISOString() });
  if (window.__ournetBreadcrumbs.length > MAX_BREADCRUMBS) {
    window.__ournetBreadcrumbs.shift();
  }
}

// Call from catch blocks alongside console.error to capture handled errors
export function addCaughtError(message, component) {
  if (!window.__ournetErrors) window.__ournetErrors = [];
  window.__ournetErrors.push({
    message: String(message),
    source: component || 'caught',
    time: new Date().toISOString()
  });
  if (window.__ournetErrors.length > MAX_ERRORS) {
    window.__ournetErrors.shift();
  }
}

export function initErrorCapture() {
  // Initialize arrays
  window.__ournetErrors = [];
  window.__ournetBreadcrumbs = [];

  // Capture unhandled JS errors
  window.onerror = (message, source, lineno, colno) => {
    window.__ournetErrors.push({
      message: String(message),
      source: source ? source.split('/').pop() : '',
      line: lineno,
      col: colno,
      time: new Date().toISOString()
    });
    if (window.__ournetErrors.length > MAX_ERRORS) {
      window.__ournetErrors.shift();
    }
  };

  // Capture unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    window.__ournetErrors.push({
      message: reason?.message || String(reason),
      source: 'unhandledrejection',
      time: new Date().toISOString()
    });
    if (window.__ournetErrors.length > MAX_ERRORS) {
      window.__ournetErrors.shift();
    }
  });

  // Track navigation breadcrumbs via custom events
  window.addEventListener('ournet:navigate', (event) => {
    if (!window.__ournetBreadcrumbs) window.__ournetBreadcrumbs = [];
    const { view, articleId, chatId, eventId, group } = event.detail || {};
    window.__ournetBreadcrumbs.push({
      type: 'navigate',
      view,
      itemId: articleId || chatId || eventId || group?.id || null,
      time: new Date().toISOString()
    });
    if (window.__ournetBreadcrumbs.length > MAX_BREADCRUMBS) {
      window.__ournetBreadcrumbs.shift();
    }
  });

  window.addEventListener('ournet:area-changed', (event) => {
    if (!window.__ournetBreadcrumbs) window.__ournetBreadcrumbs = [];
    const { areaId, areaCode, displayName } = event.detail || {};
    window.__ournetBreadcrumbs.push({
      type: 'area-changed',
      areaCode,
      displayName,
      time: new Date().toISOString()
    });
    if (window.__ournetBreadcrumbs.length > MAX_BREADCRUMBS) {
      window.__ournetBreadcrumbs.shift();
    }
  });
}
